import { useId } from "react";
import { useTranslation } from "react-i18next";
import { ROOM_PASSWORD_MAX_LENGTH } from "../../../shared/room-schema.ts";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { cn } from "../../lib/utils";
import {
  roomErrorClass,
  roomFormClass,
  roomInputClass,
  roomLabelClass,
  roomErrorMessage,
} from "./room-form";

export function JoinPasscodeForm({
  busy,
  error,
  onSubmit,
}: {
  busy: boolean;
  error: string;
  onSubmit: (_password: string) => void;
}) {
  const { t } = useTranslation();
  const id = useId();
  return (
    <form
      className={roomFormClass}
      onSubmit={(event) => {
        event.preventDefault();
        if (!busy) onSubmit(String(new FormData(event.currentTarget).get("password") ?? ""));
      }}
    >
      <Label htmlFor={`${id}-password`} className={roomLabelClass}>
        {t("home.password")}
      </Label>
      <Input
        id={`${id}-password`}
        type="password"
        name="password"
        required
        autoFocus
        maxLength={ROOM_PASSWORD_MAX_LENGTH}
        autoComplete="current-password"
        aria-describedby={error ? `${id}-error` : undefined}
        className={roomInputClass}
      />
      {error ? (
        <p
          id={`${id}-error`}
          className={cn("mt-1.75 mb-0 text-sm leading-loose", roomErrorClass)}
          role="alert"
        >
          {roomErrorMessage(t, error)}
        </p>
      ) : null}
      <Button disabled={busy}>{t(busy ? "home.joining" : "home.join")}</Button>
    </form>
  );
}
